import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Analytics24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M9.94692 4.32192C10.1931 4.07578 10.5269 3.9375 10.875 3.9375H13.125C13.4731 3.9375 13.8069 4.07578 14.0531 4.32192C14.2992 4.56806 14.4375 4.9019 14.4375 5.25V18.5625H15.1875V8.625C15.1875 8.27691 15.3258 7.94306 15.5719 7.69692C15.8181 7.45078 16.1519 7.3125 16.5 7.3125H18.75C19.0981 7.3125 19.4319 7.45078 19.6781 7.69692C19.9242 7.94306 20.0625 8.27691 20.0625 8.625V18.5625H20.4375C20.8517 18.5625 21.1875 18.8983 21.1875 19.3125C21.1875 19.7267 20.8517 20.0625 20.4375 20.0625H3.5625C3.14829 20.0625 2.8125 19.7267 2.8125 19.3125C2.8125 18.8983 3.14829 18.5625 3.5625 18.5625H3.9375V12C3.9375 11.6519 4.07578 11.3181 4.32192 11.0719C4.56806 10.8258 4.9019 10.6875 5.25 10.6875H7.5C7.8481 10.6875 8.18194 10.8258 8.42808 11.0719C8.67422 11.3181 8.8125 11.6519 8.8125 12V18.5625H9.5625V5.25C9.5625 4.9019 9.70078 4.56806 9.94692 4.32192ZM11.0625 18.5625H12.9375V5.4375H11.0625V18.5625ZM7.3125 18.5625V12.1875H5.4375V18.5625H7.3125ZM18.5625 18.5625V8.8125H16.6875V18.5625H18.5625Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
